import styled from 'styled-components'

export const ProductContainer = styled.div`
height: auto;
width: 100%;
padding: 10px;
display: flex;
flex-direction: column;
gap: 20px;
overflow-x: auto;
overflow-y: auto;
`
export const ImageLabel = styled.div`
font-style: italic;
cursor: pointer;
color: #1876d1;
text-decoration: underline;
`
export const ActionImg = styled.img`
`
export const ProductImage = styled.img`
height: 100px;
width: 100px;
border-radius: 7px;
`
export const ProductName = styled.div`
`